import React, { Fragment } from 'react';
import { Accordion } from 'react-bootstrap';
import '../../../styles/itens.scss';


const Item = (props) => {
    return (
        <Fragment>
            <Accordion.Item eventKey="0">
                <Accordion.Header>{props.categoria}: <strong>{props.titulo}</strong></Accordion.Header>
                <Accordion.Body>
                    {props.descricao}
                </Accordion.Body>
            </Accordion.Item>
            <br/>
        </Fragment>
    );
}

export default Item;